import { ReactNode } from 'react';
import clsx from 'clsx';
import { DeliveryInformationStatus, ProductDetailInfoCTAProps } from '@headless-workspace/domain/common/client';
import {
    GlowChip,
    GlowIcon,
    GlowSkeleton,
    GlowTextBody,
    PropsWithClassName,
    PropsWithIcon,
} from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';

type DeliveryInformationProps =
    | {
          isLoading: true;
      }
    | ({
          isLoading: false;
          title: string;
          description?: string;
          status: DeliveryInformationStatus;
          cta?: ReactNode;
          menu?: ProductDetailInfoCTAProps['menu'];
      } & PropsWithClassName &
          PropsWithIcon);

export const DeliveryInformation: Component<DeliveryInformationProps> = (props) => {
    if (props.isLoading) {
        return (
            <div className={'flex flex-col gap-1 w-full px-1'}>
                <div className={'flex flex-row gap-1 w-full'}>
                    <GlowSkeleton height={'2rem'} width={'2rem'} />
                    <div className={'flex flex-col gap-0.25 w-full'}>
                        <GlowSkeleton height={'1.5rem'} containerClassName={'w-full'} />
                        <GlowSkeleton height={'1.5rem'} containerClassName={'w-full'} />
                        <GlowSkeleton height={'1.5rem'} containerClassName={'w-full'} />
                    </div>
                </div>
                <GlowSkeleton height={'3rem'} containerClassName={'w-full'} />
            </div>
        );
    }

    const { Icon, title, description, status, cta, className } = props;

    return (
        <div className={clsx('flex flex-col gap-1', 'w-full', 'px-1', className)}>
            <div className={'flex flex-row gap-1 w-full text-text-primary'}>
                <GlowIcon Icon={Icon} type={'large'} />
                <div className={'flex flex-col gap-0.5 w-full'}>
                    <div className={'flex flex-col'}>
                        <GlowTextBody text={title} fontWeight={'bold'} />
                        {description && <GlowTextBody text={description} />}
                    </div>
                    <div className={'flex flex-row gap-0.5'}>
                        <GlowChip hasDigit={false} status={status.chip} size={'medium'} className={'mt-0.375'} />
                        <GlowTextBody text={status.label} />
                    </div>
                </div>
            </div>
            {cta}
        </div>
    );
};
